module.exports = "#my-custom-window {\n  font-size: 14px;\n  font-weight: 100;\n}"


/*****************
 ** WEBPACK FOOTER
 ** ./src/sample/style.txt
 ** module id = 28
 ** module chunks = 0
 **/